import React from 'react';

function AlbumSearchSkeleton({
    label = 'Searching MusicBrainz...',
    album = null,
    loading = true,
    showBack = false,
    showNext = false,
    onBack,
    onNext
}) {
    const hasTitle = Boolean(album?.title);
    const hasArtist = Boolean(album?.artist);
    const hasCountry = Boolean(album?.country);
    const hasReleaseDate = Boolean(album?.releaseDate);
    const hasTags = Array.isArray(album?.tags) && album.tags.length > 0;
    const hasCover = Boolean(album?.albumCover);

    const renderValue = (hasValue, value, placeholderClass) => {
        if (hasValue) return <span>{value}</span>;
        if (loading) return <div className={`h-4 bg-gray-700 rounded animate-pulse ${placeholderClass}`}></div>;
        return <span className="text-gray-500">-</span>;
    };

    return (
        <div className="w-full max-w-lg mb-5">
            {label && <div className="text-sm text-gray-400 mb-2">{label}</div>}
            <div className="bg-gray-800 rounded-lg p-4">
                <div className="flex items-start gap-6">
                    <div className="flex-1 space-y-2 text-gray-300">
                        <div className="flex items-center gap-2">
                            <span className="font-semibold">Artist:</span>
                            {renderValue(hasArtist, album?.artist, 'w-1/2')}
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-semibold">Title:</span>
                            {renderValue(hasTitle, album?.title, 'w-2/3')}
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-semibold">Country:</span>
                            {renderValue(hasCountry, album?.country, 'w-24')}
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="font-semibold">Release year:</span>
                            {renderValue(hasReleaseDate, album?.releaseDate, 'w-16')}
                        </div>
                        <div>
                            <span className="font-semibold">Tags:</span>
                            {hasTags
                                ? <span className="ml-2">{album.tags.join(', ')}</span>
                                : loading
                                    ? <div className="h-4 bg-gray-700 rounded w-5/6 mt-1 animate-pulse"></div>
                                    : <span className="ml-2 text-gray-500">-</span>}
                        </div>
                    </div>
                    {hasCover ? (
                        <img
                            key={`${album.title}-${album.artist}`}
                            src={album.albumCover}
                            alt={album.title || 'Album cover'}
                            className="w-[150px] h-[150px] rounded object-cover"
                        />
                    ) : (
                        <div className={`w-[150px] h-[150px] bg-gray-700 rounded ${loading ? 'animate-pulse' : ''}`}></div>
                    )}
                </div>
                <div className="mt-6 flex gap-3">
                    {showBack ? (
                        <button
                            onClick={onBack}
                            className="text-gray-400 hover:text-white flex items-center gap-2 transition"
                        >
                            <i className="fas fa-arrow-left"></i> Back
                        </button>
                    ) : loading ? (
                        <div className="h-9 bg-gray-700 rounded w-24 animate-pulse"></div>
                    ) : (
                        <div className="h-9 w-24"></div>
                    )}

                    {showNext ? (
                        <button
                            onClick={onNext}
                            className="ml-auto text-gray-400 hover:text-white flex items-center gap-2 transition"
                        >
                            Forth <i className="fas fa-arrow-right"></i>
                        </button>
                    ) : loading ? (
                        <div className="h-9 bg-gray-700 rounded w-24 animate-pulse ml-auto"></div>
                    ) : (
                        <div className="h-9 w-24 ml-auto"></div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default AlbumSearchSkeleton;